import { ReactElement } from "react";
import { Tooltip } from "@mui/material";

export const wrapWithTooltip = (
  shouldWrap: boolean,
  tooltipTitle: string,
  element: ReactElement,
): ReactElement => {
  if (!shouldWrap) return element;
  return (
    <Tooltip placement="top" title={tooltipTitle}>
      {element}
    </Tooltip>
  );
};
